import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { v4 as uuid } from 'uuid';
declare var particlesJS;


@Component({
    selector: 'particles',
    templateUrl: './particles.component.html'
})
export class ParticlesComponent implements OnInit {
    uuid = uuid();

    constructor(@Inject(PLATFORM_ID) private platform: any) { }

    ngOnInit() {
        if (isPlatformBrowser(this.platform)) {
            var id='p-'+this.uuid;
            particlesJS.load(id, 'assets/particles.json', null);
        }
    }
}
